export default __webpack_public_path__ + "static/media/arrow-left.inline.c91e2f8a.svg";